import { FetchResult, NormalizedCacheObject } from 'apollo-boost';

import { addSitelinkSet } from '../../graphql/mutations/grid/banners';
import { AddSitelinkSets, GdAddSitelinkSetsInput } from '../../typings/graphql-grid';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export class SitelinksMutationExecutor {
    constructor(private client: DNAApolloClient<NormalizedCacheObject>) {}

    public async addSitelinkSet(input: GdAddSitelinkSetsInput, login: string): Promise<FetchResult<AddSitelinkSets>> {
        return await this.client.awaitMutate<AddSitelinkSets>({
            mutation: addSitelinkSet,
            login,
            variables: {
                input,
                login
            }
        });
    }
}
